module.exports = __webpack_public_path__ + "static/media/04.d63aa058.mp3";